import React from "react";
import { isViewVisible } from "../../../utils/ViewSettings";
import VisualInspectionsView from "./components/VisualInspectionsView";
import Rbac from "../../../utils/Rbac";
import t from "../../helpers/t";
import { Biscuit } from "../../../utils";

export const rbac = new Rbac({
  _rbac: {
    admin: {
      write: true,
      editVisualInspection: true,
      deleteVisualInspection: true,
      setContingent: true,
      setLocation: true,
    },
    manager: {
      write: true,
      editVisualInspection: true,
      deleteVisualInspection: true,
      setContingent: true,
      setLocation: true,
    },
    "manager-location": {
      write: false,
      editVisualInspection: false,
      deleteVisualInspection: false,
      setContingent: false,
      setLocation: false,
    },
    user: {
      write: false,
      editVisualInspection: false,
      deleteVisualInspection: false,
      setContingent: false,
      setLocation: false,
    },
    "garage-staff": {
      write: false,
      editVisualInspection: true,
      deleteVisualInspection: false,
      setContingent: false,
      setLocation: false,
    },
  },
});

export const VisualInspectionsPage = (props) => {
  let _view = typeof props.view === "undefined" || props.view === null ? "index" : props.view;
  let indexView = isViewVisible("visual_inspections") ? "visual_inspections" : "";
  const language = Biscuit.get("user.lang").replace("-", "_");
  return (
    <>
      {(_view === "visual_inspections" ||
        (_view === "index" && indexView === "visual_inspections")) && (
        <VisualInspectionsView
          name={t("visual_inspections")}
          dispatch={props.dispatch}
          params={props.params}
          returnPath={props.returnPath}
          rbac={rbac}
          isViewVisible={isViewVisible}
          t={t}
          Biscuit={Biscuit}
          language={language}
        />
      )}
    </>
  );
};
